module.exports = __webpack_public_path__ + "img/avatar2.73bdd9cf.png";